import { render, staticRenderFns } from "./ProcesoCompraConRecinto.vue?vue&type=template&id=35e2e36e"
import script from "./ProcesoCompraConRecinto.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraConRecinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports